import React from 'react';

const Economics = () => {
    return (
        <div>
            Economics
            Economics
        </div>
    );
}

export default Economics;
